import { render, staticRenderFns } from "./Authors.vue?vue&type=template&id=29b2842a&scoped=true&"
import script from "./Authors.vue?vue&type=script&lang=js&"
export * from "./Authors.vue?vue&type=script&lang=js&"
import style0 from "./Authors.vue?vue&type=style&index=0&id=29b2842a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b2842a",
  null
  
)

export default component.exports